import { ApiProperty } from '@nestjs/swagger';


export class StockInputRequest {
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    itemcategoryId: number;
    @ApiProperty()
    sizeId: number;
    @ApiProperty()
    itemId: number;
    @ApiProperty()
    unitId?: number;
    @ApiProperty()
    unitPrice: number;
    @ApiProperty()
    requiredQuantity: number;
    @ApiProperty()
    existingQuantity: number;
    @ApiProperty()
    assignedQuantity: number;
    @ApiProperty()
    itemSubCategoryId?: number;
    @ApiProperty()
    createdUser?: string;
    @ApiProperty()
    packingmaterialId? :number;
    @ApiProperty()
    locationWiseStock? :any[];


    constructor(saleOrderId: number, itemcategoryId: number, sizeId: number, itemId: number, requiredQuantity: number, existingQuantity: number, assignedQuantity: number, unitPrice?: number, unitId?: number, itemSubCategoryId?: number, createdUser?: string,packingmaterialId?:number,locationWiseStock? :any[]) {
        this.saleOrderId = saleOrderId;
        this.itemcategoryId = itemcategoryId;
        this.sizeId = sizeId;
        this.itemId = itemId;
        this.unitId = unitId;
        this.unitPrice = unitPrice;
        this.requiredQuantity = requiredQuantity;
        this.existingQuantity = existingQuantity;
        this.assignedQuantity = assignedQuantity;
        this.itemSubCategoryId = itemSubCategoryId;
        this.createdUser = createdUser;
        this.packingmaterialId = packingmaterialId;
        this.locationWiseStock = locationWiseStock;
    }

}